export default __webpack_public_path__ + "static/media/arrow_back.d49f6e12.svg";